import React, { useState } from 'react';
import AppsIcon from '@mui/icons-material/Apps';

import IButton from '../1elements/Buttons/IButton';
import IMenu from '../2compounds/IMenu';
import ILink from '../1elements/ILink';
import ITooltip from '../1elements/ITooltip';
import drive from '../1elements/Icons/png/google-drive.png';
import gmail from '../1elements/Icons/png/google-gmail.png';
import calendar from '../1elements/Icons/png/google-calendar.png';
import chat from '../1elements/Icons/png/google-chat.png';
import meet from '../1elements/Icons/png/google-meet.png';
import docs from '../1elements/Icons/png/google-docs.png';
import sheets from '../1elements/Icons/png/google-sheets.png';
import { establishOrRefreshSession } from '../../common/sessionGate';
import slides from '../1elements/Icons/png/google-slides.png';
export default function AppsMenuGoogle() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    establishOrRefreshSession();
  };

  const handleClose = () => {
    setAnchorEl(null);
    establishOrRefreshSession();
  };

  const open = Boolean(anchorEl);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
    establishOrRefreshSession();
  };

  return (
    <div>
      <ITooltip content="Apps" placement="right" arrow>
        <IButton isMenu handleClick={handleClick} opened={Boolean(anchorEl)}>
          <AppsIcon />
        </IButton>
      </ITooltip>

      <IMenu
        position="left_center"
        type="icon"
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
      >
        <ILink onClick={() => openInNewTab('https://gmail.com')}>
          <ITooltip content="Gmail" placement="top">
            <img src={gmail} alt="Gmail" style={{ width: 25, height: 25 }} />
          </ITooltip>
        </ILink>
        <ILink onClick={() => openInNewTab('https://drive.google.com')}>
          <ITooltip content="Drive" placement="top">
            <img
              src={drive}
              alt="Google Drive"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink onClick={() => openInNewTab('https://calendar.google.com')}>
          <ITooltip content="Calendar" placement="top">
            <img
              src={calendar}
              alt="Google Calendar"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink onClick={() => openInNewTab('https://chat.google.com')}>
          <ITooltip content="Chat" placement="top">
            <img
              src={chat}
              alt="Google Chat"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink onClick={() => openInNewTab('https://meet.google.com')}>
          <ITooltip content="Meet" placement="top">
            <img
              src={meet}
              alt="Google Meet"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink onClick={() => openInNewTab('https://docs.google.com/document')}>
          <ITooltip content="Docs" placement="top">
            <img
              src={docs}
              alt="Google Docs"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink
          onClick={() => openInNewTab('https://docs.google.com/spreadsheets')}
        >
          <ITooltip content="Sheets" placement="top">
            <img
              src={sheets}
              alt="Google Sheets"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
        <ILink
          onClick={() => openInNewTab('https://docs.google.com/presentation')}
        >
          <ITooltip content="Slides" placement="top">
            <img
              src={slides}
              alt="Google Slides"
              style={{ width: 25, height: 25 }}
            />
          </ITooltip>
        </ILink>
      </IMenu>
    </div>
  );
}
